import OkraPage from './OkraPage';

export default OkraPage;
